import LimitedClient from '@/dataAccess/models/LimitedClient'
import { OrmModel, StringField } from 'vuex-orm-decorators'
import { ApiResponse } from '@/dataAccess/dto/DTO'

@OrmModel('accessibleClients', 'limitedClients')
export default class AccessibleClient extends LimitedClient {
  @StringField()
  public avatar: string // TODO should be avatarUrl
  @StringField()
  public adminChangeUrl: string

  // TODO investigate possibility to configure inheritance in a way which
  //  does not require `o.adminChangeUrl` check
  // NB! Do not use `all()` method for it will also return LimitedClients.
  static notArchivedAndAccessibleToUser() {
    return super
      .all()
      .filter((o: AccessibleClient) => o.adminChangeUrl && !o.isArchived)
  }

  /*
   * Configuration for Vuex ORM Plugin Axios
   */
  static apiConfig = {
    // eslint-disable-next-line
    dataTransformer({ data, headers }) {
      return data.map(o => AccessibleClient.apiResponseMapper(o))
    }
  }

  /**
   * Map API response data structure to AccessibleClient date structure
   */
  static apiResponseMapper(data: ApiResponse): ApiResponse {
    return {
      ...LimitedClient.apiResponseMapper(data),
      avatar: data.profile_picture,
      adminChangeUrl: data.admin_change_url
    }
  }
}
